/* eslint-disable */
import * as util from "@/api/otp";

const state = {
};


const mutations = {
    SET_fields: (state, value) => {
        state.fields = value
    },
};

const actions = {
    confirm({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.confirm(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/otp.js